
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import Layout from "../../components/Layout";

/*
 * Каркас страниц генератора вывесок — как у «Подготовки сметы» и КП:
 * кнопка «Назад», заголовок по центру, справа действия; ниже — содержимое.
 */

export const SIGNS_ROOT = "/admin/print-signs";

/** Страница: шапка + содержимое. wide — на всю ширину (редактор), иначе по центру. */
export const SignsPage = ({ title, subtitle, back = SIGNS_ROOT, backLabel = "Назад", onBack, actions, wide, children }) => {
    const navigate = useNavigate();
    return (
        <Layout sidebar>
            <div className={`printCatalogs printSigns signsPage${wide ? " is-wide" : ""}`}>
                <header className="signsPage__head">
                    <button type="button" className="signsPage__back" onClick={() => (onBack ? onBack() : navigate(back))}>
                        <span aria-hidden="true">‹</span> {backLabel}
                    </button>
                    <div className="signsPage__title">
                        <h1>{title}</h1>
                        {subtitle ? <p>{subtitle}</p> : null}
                    </div>
                    <div className="signsPage__actions">{actions || null}</div>
                </header>
                {children}
            </div>
        </Layout>
    );
};

/**
 * Кнопка «··· Действия» с выпадающим меню.
 * items: [{ label, onClick, danger, disabled, divider }] — divider ставит черту перед пунктом.
 */
export const ActionsMenu = ({ items, label = "Действия", disabled, busy }) => {
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);

    useEffect(() => {
        if (!open) return undefined;
        const onDown = (event) => {
            if (rootRef.current && !rootRef.current.contains(event.target)) setOpen(false);
        };
        const onKey = (event) => event.key === "Escape" && setOpen(false);
        document.addEventListener("mousedown", onDown);
        document.addEventListener("keydown", onKey);
        return () => {
            document.removeEventListener("mousedown", onDown);
            document.removeEventListener("keydown", onKey);
        };
    }, [open]);

    return (
        <div className={`signsMenu${open ? " is-open" : ""}`} ref={rootRef}>
            <button type="button" className="signsMenu__button" disabled={disabled} onClick={() => setOpen((value) => !value)}>
                <span className="signsMenu__dots" aria-hidden="true">···</span> {busy || label}
            </button>
            {open ? (
                <div className="signsMenu__list" role="menu">
                    {items.filter(Boolean).map((item) => (
                        <button
                            key={item.label}
                            type="button"
                            role="menuitem"
                            className={`signsMenu__item${item.danger ? " is-danger" : ""}${item.divider ? " has-divider" : ""}`}
                            disabled={item.disabled}
                            onClick={() => {
                                setOpen(false);
                                item.onClick();
                            }}
                        >
                            {item.label}
                        </button>
                    ))}
                </div>
            ) : null}
        </div>
    );
};

/** Цветная метка статуса, как «final / draft» в сметах. */
export const StatusBadge = ({ tone = "muted", children }) => (
    <span className={`signsBadge is-${tone}`}>{children}</span>
);

/** Сообщение сверху страницы (успех, ошибка, подсказка). */
export const PageMessage = ({ message, onClose }) => (message ? (
    <div className={`printCatalogs__message is-${message.type} signsPage__message`}>
        <span>{message.text}</span>
        {onClose ? <button type="button" onClick={onClose} aria-label="Закрыть">×</button> : null}
    </div>
) : null);
